__turbopack_context__.v({
  "button": "suimzW_button",
  "colorScheme--success": "suimzW_colorScheme--success",
  "container": "suimzW_container",
  "controls--left": "suimzW_controls--left",
  "controls--right": "suimzW_controls--right",
  "disabled": "suimzW_disabled",
  "iconDouble": "suimzW_iconDouble",
  "iconsDouble": "suimzW_iconsDouble",
  "item": "suimzW_item",
  "option": "suimzW_option",
  "size--sm": "suimzW_size--sm",
});
